"use strict";
import React from "react";
export const addIcon = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6 0C5.44772 0 5 0.447715 5 1V5H1C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7H5V11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H7V1C7 0.447715 6.55228 0 6 0Z",
        fill: "currentColor"
      }
    )
  );
};
export const arrowDown = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M7.97945 11.4673C7.63023 11.4673 7.3309 11.3176 7.13135 11.0682L2.19243 5.53062C1.8931 5.13152 1.94299 4.53286 2.34209 4.23353C2.74119 3.9342 3.28996 3.9342 3.58929 4.33331L7.87967 9.22234C7.92956 9.27223 7.97945 9.27223 8.07922 9.22234L12.3696 4.33331C12.7188 3.9342 13.2676 3.88432 13.6667 4.23353C14.0658 4.58275 14.1157 5.13152 13.7665 5.53062C13.7665 5.53062 13.7665 5.53062 13.7166 5.58051L8.82754 11.1181C8.62799 11.3176 8.27877 11.4673 7.97945 11.4673Z",
        fill: "currentColor"
      }
    )
  );
};
export const arrowUp = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M8.04772 4C8.39851 4 8.69919 4.15026 8.89964 4.40069L13.7606 9.91024C14.1114 10.2608 14.0613 10.8619 13.7105 11.2125C13.3597 11.5631 12.7584 11.513 12.4076 11.1624C12.4076 11.1624 12.4076 11.1624 12.3575 11.1123L8.09783 6.30399C8.04772 6.2539 7.99761 6.2539 7.89738 6.30399L3.63776 11.1123C3.28696 11.513 2.73572 11.5631 2.33481 11.2125C1.93391 10.8619 1.88379 10.3109 2.23459 9.91024C2.23459 9.91024 2.23459 9.91024 2.2847 9.86015L7.14568 4.35061C7.39625 4.15026 7.69693 4 8.04772 4Z",
        fill: "currentColor"
      }
    )
  );
};
export const externalLinkIcon = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 512 512",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34,24,24,0,0,0,34,0L422.27,111.24,458,147c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z",
        fill: "currentColor"
      }
    )
  );
};
export const copyIcon = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M13.6533 3.21352L11.7467 1.21352C11.6333 1.09898 11.4983 1.00815 11.3495 0.94634C11.2007 0.88453 11.0411 0.852977 10.88 0.853523H5.54667C5.22769 0.855223 4.92207 0.98178 4.69528 1.20608C4.46848 1.43038 4.33856 1.73459 4.33333 2.05352V3.16686H3.22C2.89644 3.16686 2.58612 3.29539 2.35733 3.52419C2.12854 3.75298 2 4.06329 2 4.38686V13.9469C2 14.2704 2.12854 14.5807 2.35733 14.8095C2.58612 15.0383 2.89644 15.1669 3.22 15.1669H10.4467C10.7702 15.1669 11.0805 15.0383 11.3093 14.8095C11.5381 14.5807 11.6667 14.2704 11.6667 13.9469V12.8335H12.78C13.1036 12.8335 13.4139 12.705 13.6427 12.4762C13.8715 12.2474 14 11.9371 14 11.6135V4.06019C14.0008 3.74326 13.8762 3.43889 13.6533 3.21352ZM10 13.8335H3.66667C3.57826 13.8335 3.49348 13.7984 3.43096 13.7359C3.36845 13.6734 3.33333 13.5886 3.33333 13.5002V4.83352C3.33333 4.74512 3.36845 4.66033 3.43096 4.59782C3.49348 4.53531 3.57826 4.50019 3.66667 4.50019H4.16667C4.21087 4.50019 4.25326 4.51775 4.28452 4.549C4.31577 4.58026 4.33333 4.62265 4.33333 4.66686V11.6135C4.33333 11.9371 4.46187 12.2474 4.69066 12.4762C4.91946 12.705 5.22977 12.8335 5.55333 12.8335H10.1667C10.2109 12.8335 10.2533 12.8511 10.2845 12.8823C10.3158 12.9136 10.3333 12.956 10.3333 13.0002V13.5002C10.3333 13.5886 10.2982 13.6734 10.2357 13.7359C10.1732 13.7984 10.0884 13.8335 10 13.8335ZM12.3333 11.5002H6C5.91159 11.5002 5.82681 11.4651 5.7643 11.4026C5.70179 11.34 5.66667 11.2553 5.66667 11.1669V2.50019C5.66667 2.41178 5.70179 2.327 5.7643 2.26449C5.82681 2.20197 5.91159 2.16686 6 2.16686H10.6667C10.7128 2.16732 10.7584 2.177 10.8008 2.19531C10.8431 2.21363 10.8814 2.24022 10.9133 2.27352L12.5733 4.00019C12.603 4.02998 12.6265 4.06534 12.6426 4.10423C12.6586 4.14312 12.6668 4.18479 12.6667 4.22686V11.1669C12.6667 11.2553 12.6315 11.34 12.569 11.4026C12.5065 11.4651 12.4217 11.5002 12.3333 11.5002Z",
        fill: "currentColor"
      }
    ))
  );
};
export const successIcon = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM12.62 5.46667L8.05334 11.66C8.0002 11.7324 7.93297 11.7933 7.8557 11.8391C7.77843 11.8849 7.6927 11.9146 7.60366 11.9265C7.51462 11.9383 7.42411 11.932 7.33756 11.908C7.25101 11.884 7.17021 11.8427 7.1 11.7867L3.84 9.18C3.77152 9.12498 3.71458 9.05698 3.67247 8.97989C3.63035 8.90279 3.60389 8.81814 3.59459 8.73079C3.5853 8.64344 3.59336 8.55511 3.61832 8.47088C3.64327 8.38666 3.68463 8.30819 3.74 8.24C3.85078 8.10557 4.00977 8.01984 4.18296 8.00115C4.35614 7.98247 4.52976 8.0323 4.66667 8.14L7.38667 10.3133L11.5467 4.66667C11.6516 4.5261 11.8078 4.43257 11.9813 4.40636C12.1547 4.38015 12.3315 4.42338 12.4733 4.52667C12.5453 4.57824 12.6064 4.64364 12.6528 4.71906C12.6993 4.79447 12.7302 4.87839 12.7439 4.9659C12.7575 5.05341 12.7536 5.14277 12.7323 5.22875C12.7111 5.31473 12.6729 5.39561 12.62 5.46667Z",
        fill: "#14994C"
      }
    )
  );
};
export const warningIcon = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M15.8471 13.9617L9.18279 0.744345C9.06983 0.519844 8.90023 0.331839 8.69233 0.20065C8.48443 0.0694619 8.24614 7.879e-05 8.0032 0C7.76027 7.879e-05 7.52197 0.0694619 7.31407 0.20065C7.10617 0.331839 6.93658 0.519844 6.82361 0.744345L0.15927 13.9617C0.0483055 14.1768 -0.00641988 14.4187 0.000599508 14.6629C0.00761889 14.9072 0.0761354 15.1452 0.199256 15.353C0.320703 15.5532 0.48913 15.7177 0.688569 15.8309C0.888007 15.9442 1.11184 16.0023 1.33886 15.9999H14.6675C14.897 15.9999 15.1225 15.938 15.3223 15.8203C15.5221 15.7026 15.6894 15.533 15.808 15.328C15.9266 15.1231 15.9925 14.8896 15.9994 14.6502C16.0063 14.4109 15.9538 14.1737 15.8471 13.9617ZM7.33677 5.56519C7.33677 5.38069 7.40698 5.20375 7.53196 5.07329C7.65694 4.94284 7.82645 4.86954 8.0032 4.86954C8.17995 4.86954 8.34946 4.94284 8.47444 5.07329C8.59942 5.20375 8.66964 5.38069 8.66964 5.56519V9.73909C8.66964 9.92358 8.59942 10.1005 8.47444 10.231C8.34946 10.3614 8.17995 10.4347 8.0032 10.4347C7.82645 10.4347 7.65694 10.3614 7.53196 10.231C7.40698 10.1005 7.33677 9.92358 7.33677 9.73909V5.56519ZM8.03652 13.5652C7.77404 13.5636 7.52225 13.4564 7.33356 13.2659C7.14488 13.0754 7.03383 12.8163 7.02354 12.5426C7.01909 12.405 7.04108 12.268 7.08823 12.1395C7.13539 12.011 7.20673 11.8937 7.29806 11.7944C7.38939 11.6952 7.49884 11.6161 7.61996 11.5618C7.74107 11.5075 7.87139 11.4791 8.0032 11.4782C8.26569 11.4798 8.51748 11.587 8.70616 11.7775C8.89485 11.9679 9.00589 12.227 9.01618 12.5008C9.02064 12.6383 8.99864 12.7754 8.95149 12.9039C8.90434 13.0324 8.83299 13.1497 8.74166 13.2489C8.65034 13.3481 8.54088 13.4273 8.41977 13.4816C8.29866 13.5359 8.16834 13.5643 8.03652 13.5652Z",
        fill: "#FFC229"
      }
    )
  );
};
export const errorAlertIcon = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "12",
      fill: "none",
      viewBox: "0 0 16 16"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "tomato",
        "fill-rule": "evenodd",
        d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm2.73-11.583a.853.853 0 0 1 .79.528.854.854 0 0 1-.187.935L9.207 8l2.126 2.127a.853.853 0 0 1 0 1.206.873.873 0 0 1-1.213 0L8 9.2l-2.113 2.133a.863.863 0 1 1-1.22-1.22L6.8 8 4.667 5.88a.867.867 0 0 1 .279-1.403.853.853 0 0 1 .94.19L8 6.793l2.127-2.126c.16-.16.377-.25.603-.25Z",
        "clip-rule": "evenodd"
      }
    )
  );
};
export const successAlertIcon = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "12",
      fill: "none",
      viewBox: "0 0 16 16"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#009F42",
        d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm4.62 5.467L8.053 11.66a.667.667 0 0 1-.953.127L3.84 9.18a.667.667 0 0 1-.1-.94.667.667 0 0 1 .927-.1l2.72 2.173 4.16-5.646a.666.666 0 0 1 1.106.052.667.667 0 0 1-.033.748Z"
      }
    )
  );
};
export const aiIcon = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M8.23 6.08c.36-1.05 1.82-1.08 2.24-.1l.04.1.49 1.42c.11.33.29.63.53.88.23.25.52.45.85.58l.13.05 1.42.49c1.05.36 1.08 1.82.1 2.24l-.1.04-1.42.49c-.33.11-.63.29-.88.53-.25.23-.45.52-.58.85l-.05.13-.49 1.42c-.36 1.05-1.82 1.08-2.24.1l-.04-.1-.49-1.42a2.2 2.2 0 0 0-.53-.88 2.2 2.2 0 0 0-.85-.58l-.13-.05-1.42-.49c-1.05-.36-1.08-1.82-.1-2.24l.1-.04 1.42-.49c.33-.11.63-.29.88-.53.25-.23.45-.52.58-.85l.05-.13.49-1.42ZM14.19 4c.11 0 .22.03.32.09.1.06.18.15.23.25l.03.07.21.62.62.21c.11.04.21.11.28.2.08.1.12.22.12.34 0 .12-.03.24-.1.34a.55.55 0 0 1-.26.21l-.07.03-.62.21-.21.62a.55.55 0 0 1-.21.26.55.55 0 0 1-.34.12.55.55 0 0 1-.34-.1.55.55 0 0 1-.21-.26l-.03-.07-.21-.62-.62-.21a.55.55 0 0 1-.28-.2.55.55 0 0 1-.12-.34c0-.12.03-.24.1-.34a.55.55 0 0 1 .26-.21l.07-.03.62-.21.21-.62c.04-.11.11-.21.2-.28.1-.08.22-.12.34-.12Z",
        fill: "#0072CE"
      }
    )
  );
};
export const aiSparkleIcon = (color = "#1D7F61") => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: { verticalAlign: "middle", marginRight: 4 }
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M10.9768 1.21692C11.0978 0.849039 11.1583 0.665098 11.2489 0.615452C11.3273 0.572519 11.4221 0.572519 11.5005 0.615452C11.5911 0.665098 11.6516 0.84904 11.7726 1.21692L11.9565 1.77611C11.9807 1.84975 11.9928 1.88658 12.0136 1.91713C12.0321 1.94418 12.0554 1.96753 12.0825 1.98598C12.113 2.0068 12.1498 2.01891 12.2235 2.04313L12.7827 2.22704C13.1506 2.34803 13.3345 2.40852 13.3841 2.49913C13.4271 2.57749 13.4271 2.67234 13.3841 2.7507C13.3345 2.84132 13.1506 2.90181 12.7827 3.0228L12.2235 3.20671C12.1498 3.23093 12.113 3.24304 12.0825 3.26386C12.0554 3.2823 12.0321 3.30566 12.0136 3.33271C11.9928 3.36326 11.9807 3.40008 11.9565 3.47373L11.7726 4.03291C11.6516 4.4008 11.5911 4.58474 11.5005 4.63439C11.4221 4.67732 11.3273 4.67732 11.2489 4.63439C11.1583 4.58474 11.0978 4.4008 10.9768 4.03291L10.7929 3.47373C10.7687 3.40008 10.7566 3.36326 10.7357 3.33271C10.7173 3.30566 10.6939 3.2823 10.6669 3.26386C10.6363 3.24304 10.5995 3.23093 10.5259 3.20671L9.96668 3.0228C9.59879 2.90181 9.41485 2.84132 9.36521 2.7507C9.32227 2.67234 9.32227 2.57749 9.36521 2.49913C9.41485 2.40852 9.5988 2.34803 9.96668 2.22704L10.5259 2.04313C10.5995 2.01891 10.6363 2.0068 10.6669 1.98598C10.6939 1.96753 10.7173 1.94418 10.7357 1.91713C10.7566 1.88658 10.7687 1.84975 10.7929 1.77611L10.9768 1.21692Z",
        fill: color
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        "clip-rule": "evenodd",
        d: "M5.29934 2.03237C5.6318 1.85021 6.03421 1.85021 6.36667 2.03237C6.62977 2.17652 6.77484 2.46387 6.87987 2.7119C6.99389 2.98115 7.11516 3.3499 7.26502 3.80559L7.74463 5.26391C7.81492 5.47763 7.82694 5.50129 7.8375 5.51678C7.8541 5.54114 7.87512 5.56216 7.89948 5.57876C7.91497 5.58932 7.93863 5.60134 8.15235 5.67163L9.61063 6.15123C10.0663 6.3011 10.4351 6.42237 10.7044 6.53639C10.9524 6.64142 11.2397 6.78649 11.3839 7.04959C11.566 7.38205 11.566 7.78446 11.3839 8.11692C11.2397 8.38002 10.9524 8.52508 10.7044 8.63011C10.4351 8.74413 10.0663 8.8654 9.61066 9.01527L8.15235 9.49488C7.93863 9.56517 7.91497 9.57718 7.89948 9.58774C7.87512 9.60434 7.8541 9.62537 7.8375 9.64972C7.82694 9.66521 7.81492 9.68887 7.74463 9.9026L7.26502 11.3609C7.11516 11.8166 6.99388 12.1854 6.87987 12.4546C6.77484 12.7026 6.62977 12.99 6.36667 13.1341C6.03421 13.3163 5.6318 13.3163 5.29934 13.1341C5.03624 12.99 4.89118 12.7026 4.78615 12.4546C4.67213 12.1854 4.55087 11.8166 4.40101 11.361L3.92138 9.9026C3.85109 9.68887 3.83908 9.66521 3.82852 9.64972C3.81191 9.62537 3.79089 9.60434 3.76654 9.58774C3.75105 9.57718 3.72739 9.56517 3.51366 9.49487L2.05536 9.01527C1.59968 8.86541 1.23091 8.74413 0.961657 8.63011C0.713625 8.52508 0.426272 8.38002 0.282123 8.11692C0.0999696 7.78446 0.0999696 7.38205 0.282123 7.04959C0.426272 6.78649 0.713625 6.64142 0.961657 6.53639C1.23091 6.42237 1.59966 6.3011 2.05534 6.15124L3.51366 5.67163C3.72739 5.60134 3.75105 5.58932 3.76654 5.57876C3.79089 5.56216 3.81191 5.54114 3.82852 5.51678C3.83908 5.50129 3.85109 5.47763 3.92138 5.26391L4.40099 3.80562C4.55085 3.34992 4.67213 2.98116 4.78615 2.7119C4.89118 2.46387 5.03624 2.17652 5.29934 2.03237ZM5.72843 2.79523C5.72821 2.79574 5.72726 2.79698 5.72561 2.79913C5.71396 2.81431 5.6672 2.87524 5.59188 3.0531C5.49379 3.28474 5.38364 3.61849 5.22548 4.09937L4.75259 5.53727L4.74082 5.57318C4.69077 5.72622 4.64104 5.8783 4.55151 6.00964C4.47326 6.12442 4.37418 6.22351 4.2594 6.30175C4.12806 6.39128 3.97598 6.44102 3.82294 6.49106L3.78703 6.50283L2.34913 6.97573C1.86824 7.13388 1.5345 7.24403 1.30285 7.34213C1.125 7.41744 1.06406 7.46421 1.04888 7.47586C1.04673 7.47751 1.0455 7.47845 1.04498 7.47868C1.01235 7.54456 1.01235 7.62195 1.04498 7.68783C1.0455 7.68805 1.04673 7.689 1.04888 7.69065C1.06406 7.7023 1.12499 7.74906 1.30285 7.82438C1.5345 7.92247 1.86824 8.03262 2.34913 8.19078L3.78703 8.66367L3.82293 8.67544C3.97597 8.72548 4.12806 8.77522 4.2594 8.86475C4.37418 8.943 4.47326 9.04208 4.55151 9.15686C4.64104 9.2882 4.69077 9.44028 4.74082 9.59332L4.75258 9.62923L5.22548 11.0671C5.38364 11.548 5.49379 11.8818 5.59188 12.1134C5.6672 12.2913 5.71396 12.3522 5.72561 12.3674C5.72725 12.3695 5.72821 12.3708 5.72843 12.3713C5.79431 12.4039 5.8717 12.4039 5.93758 12.3713C5.93772 12.371 5.93813 12.3704 5.93881 12.3695C5.93924 12.3689 5.93977 12.3682 5.9404 12.3674C5.95205 12.3522 5.99882 12.2913 6.07413 12.1134C6.17223 11.8818 6.28238 11.548 6.44053 11.0671L6.91343 9.62923L6.92519 9.59332C6.97524 9.44028 7.02498 9.2882 7.11451 9.15686C7.19275 9.04208 7.29184 8.943 7.40662 8.86475C7.53796 8.77522 7.69004 8.72549 7.84308 8.67544L7.87899 8.66367L9.31688 8.19078C9.79777 8.03262 10.1315 7.92247 10.3632 7.82438C10.541 7.74906 10.602 7.7023 10.6171 7.69065C10.6193 7.68901 10.6205 7.68805 10.621 7.68783C10.6537 7.62195 10.6537 7.54456 10.621 7.47868C10.6205 7.47845 10.6193 7.47751 10.6172 7.47587C10.602 7.46422 10.541 7.41744 10.3632 7.34213C10.1315 7.24403 9.79777 7.13388 9.31688 6.97573L7.87899 6.50283L7.84308 6.49106C7.69004 6.44102 7.53796 6.39128 7.40662 6.30175C7.29184 6.22351 7.19275 6.12442 7.11451 6.00964C7.02498 5.8783 6.97524 5.72622 6.92519 5.57318L6.91343 5.53727L6.44053 4.09938C6.28238 3.61849 6.17223 3.28474 6.07413 3.0531C5.99882 2.87524 5.95205 2.81431 5.9404 2.79913C5.93875 2.79698 5.93781 2.79574 5.93758 2.79523C5.87171 2.76259 5.79431 2.76259 5.72843 2.79523Z",
        fill: color
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M11.2848 10.5229C11.2201 10.5584 11.1769 10.6898 11.0905 10.9525L10.9591 11.352C10.9418 11.4046 10.9332 11.4309 10.9183 11.4527C10.9051 11.472 10.8884 11.4887 10.8691 11.5019C10.8473 11.5167 10.821 11.5254 10.7684 11.5427L10.369 11.674C10.1062 11.7605 9.9748 11.8037 9.93934 11.8684C9.90867 11.9244 9.90867 11.9921 9.93934 12.0481C9.9748 12.1128 10.1062 12.156 10.369 12.2425L10.7684 12.3738C10.821 12.3911 10.8473 12.3998 10.8691 12.4146C10.8884 12.4278 10.9051 12.4445 10.9183 12.4638C10.9332 12.4856 10.9418 12.5119 10.9591 12.5645L11.0905 12.964C11.1769 13.2267 11.2201 13.3581 11.2848 13.3936C11.3408 13.4243 11.4085 13.4243 11.4645 13.3936C11.5292 13.3581 11.5725 13.2267 11.6589 12.964L11.7902 12.5645C11.8075 12.5119 11.8162 12.4856 11.8311 12.4638C11.8442 12.4445 11.8609 12.4278 11.8802 12.4146C11.9021 12.3998 11.9284 12.3911 11.981 12.3738L12.3804 12.2425C12.6432 12.156 12.7745 12.1128 12.81 12.0481C12.8407 11.9921 12.8407 11.9244 12.81 11.8684C12.7745 11.8037 12.6432 11.7605 12.3804 11.6741L11.981 11.5427C11.9284 11.5254 11.9021 11.5167 11.8802 11.5019C11.8609 11.4887 11.8442 11.472 11.8311 11.4527C11.8162 11.4309 11.8075 11.4046 11.7902 11.352L11.6589 10.9525C11.5725 10.6898 11.5292 10.5584 11.4645 10.5229C11.4085 10.4923 11.3408 10.4923 11.2848 10.5229Z",
        fill: color
      }
    )
  );
};
